import { useSelector, useDispatch } from 'react-redux';
import { addNewGroup, editProp, editGroupSettingsProp } from 'state/fence/fenceSlice';
import { openModal } from 'state/modal/modalSlice';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';
import style from './FenceCanvasHeader.module.scss';

const FenceCanvasHeader = ({ onOpenAddElementModal }) => {
  const dispatch = useDispatch();
  const fence = useSelector((state) => state.fence);

  const openEditSettingsModal = () => {
    dispatch(editGroupSettingsProp({ prop: 'readyToDesign', value: false }));
  };

  const openEditRailStyleModal = () => {
    dispatch(openModal('edit-rail-style'));
  };

  const openRemoveFenceGroupModal = (id, index) => {
    dispatch(
      openModal({
        activeName: 'remove-fence-group',
        props: { id, index },
      })
    );
  };

  const changeCurrentGroup = (id) => {
    dispatch(editProp({ prop: 'currentGroupId', value: id }));
  };

  const addNewFenceGroup = () => {
    dispatch(addNewGroup());
  };

  return (
    <div className={style.canvasHeader}>
      <div className={style.canvasHeaderRow}>
        <ul>
          <li>
            <ButtonBase onClick={openEditRailStyleModal}>
              <i className="material-symbols-outlined">palette</i> Kerítés léc megjelenése
            </ButtonBase>
          </li>
        </ul>

        <ul className={style.canvasHeaderTab}>
          {fence.groups.length &&
            fence.groups.map((group, i) => (
              <li key={group.id}>
                <ButtonBase
                  className={group.id === fence.currentGroupId ? style.canvasHeaderTabBtn : ''}
                  active={group.id === fence.currentGroupId}
                  onClick={() => changeCurrentGroup(group.id)}
                >
                  <strong className="me-xs">{i + 1}.</strong> oldal
                </ButtonBase>
                {group.id === fence.currentGroupId && (
                  <button
                    className={style.canvasHeaderTabRemove}
                    title="Oldal törlése"
                    onClick={() => openRemoveFenceGroupModal(group.id, i + 1)}
                  >
                    <i className="material-symbols-outlined">delete</i>
                  </button>
                )}
              </li>
            ))}
          <li>
            <ButtonBase color="primary" disabled={fence.groups.length >= 4} onClick={addNewFenceGroup}>
              <i className="material-symbols-outlined">add</i> Oldal hozzáadása
            </ButtonBase>
          </li>
        </ul>
      </div>

      <hr className="mb-sm" />

      <div className={style.canvasHeaderRow}>
        <ul>
          <li>
            <ButtonBase onClick={openEditSettingsModal}>
              <i className="material-symbols-outlined">straighten</i> Kerítés méretei
            </ButtonBase>
          </li>
        </ul>

        <ul>
          <li>
            <ButtonBase onClick={() => onOpenAddElementModal('column')}>
              <i className="material-symbols-outlined">add</i> Oszlop hozzáadása
            </ButtonBase>
          </li>
          <li>
            <ButtonBase onClick={() => onOpenAddElementModal('fundament')}>
              <i className="material-symbols-outlined">add</i> Lábazat hozzáadása
            </ButtonBase>
          </li>
          <li>
            <ButtonBase onClick={() => onOpenAddElementModal('door')}>
              <i className="material-symbols-outlined">add</i> Kapu hozzáadása
            </ButtonBase>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FenceCanvasHeader;
